var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRightsideArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rightside_arrow",
    "data-name": "rightside arrow",
    transform: "translate(0 -0.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron-right",
    d: "M9,16.9l5.45-5.45L9,6",
    transform: "translate(0.5 0.619)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 24,
    height: 24,
    transform: "translate(0 0.119)",
    fill: "none"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRightsideArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rightside_arrow.850c5d2209736613801a70129b311f2d.svg";